import { render, staticRenderFns } from "./defect_details.vue?vue&type=template&id=6bd0ecc4&scoped=true"
import script from "./defect_details.vue?vue&type=script&lang=js"
export * from "./defect_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0ecc4",
  null
  
)

export default component.exports